@if (receiptService.error()) { <p role="alert" class="text-danger">{{ receiptService.error() }}</p> }
<div class="receipt-paper-control d-print-none"><label>Receipt paper <select [value]="receiptService.paperWidth()" (change)="setPaperWidth($event)"><option value="58">58 mm</option><option value="80">80 mm</option></select></label></div>
@if (receipt()) {
  <div class="thermal-container" [style.width.mm]="receiptService.paperWidth()">
    <div class="header">
      @if (receipt()!.logoUrl) {
        <img [src]="receipt()!.logoUrl" alt="Logo" class="receipt-logo" (error)="onLogoError($event)">
      } @else {
        <img src="/assets/images/logo.png" alt="Kaparking Logo" class="receipt-logo" (error)="onLogoError($event)">
      }

      @if (receipt()!.crcName) {
        <h3 class="crc-name">{{ receipt()!.crcName | titlecase }}</h3>
      }

       @if (receipt()!.councilName) {
        <p class="council-name">{{ receipt()!.councilName | titlecase }}</p>
      }

      <!-- <h3 class="title">{{ receipt()!.title | titlecase }}</h3>
      @if (receipt()!.subtitle) {
        <p>{{ receipt()!.subtitle | titlecase }}</p>
      } -->
    </div>

    <div class="receipt-id">
      {{ receipt()!.title }}<br/>
      {{ receipt()!.receiptNo }}
    </div>

    <div class="details">
      <!-- Standard header fields -->
      <div class="details-row">
        <span class="label">Date:</span>
        <span class="value">{{ receipt()!.txnDate | date:'dd MMM yyyy HH:mm':'+0300' }}</span>
      </div>
      @if (receipt()!.vehicleNo) {
        <div class="details-row">
        <span class="label">{{ receipt()!.type === 'sticker' ? 'Vehicle Number' : 'Vehicle' }}:</span>
          <span class="value">{{ receipt()!.vehicleNo }}</span>
        </div>
      }
      @if (receipt()!.vehicleType) {
        <div class="details-row">
          <span class="label">Vehicle Type:</span>
          <span class="value">{{ receipt()!.vehicleType | titlecase }}</span>
        </div>
      }
      <div class="details-row">
        <span class="label">{{ receipt()!.type === 'sticker' ? 'Issued By' : 'Agent' }}:</span>
        <span class="value">{{ receipt()!.agent | titlecase }}</span>
      </div>

      <div class="asterisk-divider">**************************</div>

      @for (detail of receipt()!.details; track detail.label) {
        <div class="details-row">
          <span class="label">{{ detail.label | titlecase }}:</span>
          <span class="value">
            @if (detail.value && detail.label.toLowerCase() !== 'receipt' && detail.label.toLowerCase() !== 'ticket') {
              {{ formatDetailValue(detail.value) }}
            } @else {
              {{ detail.value }}
            }
          </span>
        </div>
      }
    </div>

    <div class="asterisk-divider">**************************</div>

    <div class="footer">
      @if (receipt()!.contactPhone || receipt()!.contactEmail) {
        <div class="inquiries">
          For Inquiries<br/>
          @if (receipt()!.contactPhone) {
            Call: {{ receipt()!.contactPhone }}<br/>
          }
          @if (receipt()!.contactEmail) {
            Email: {{ receipt()!.contactEmail | lowercase }}
          }
        </div>
      }

      @if (receipt()!.footer) {
        <p>{{ receipt()!.footer }}</p>
      } @else {
        <p>Thank you.</p>
      }
    </div>
  </div>
}
